@if (hasCardContainer) {
    <lib-card>
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </lib-card>
} @else {
    <ng-container *ngTemplateOutlet="content"></ng-container>
}

<ng-template #content>
    <div [attr.data-sb-qa]="qaTag">
        <div class="d-flex flex-column mb-3">
            <div class="d-flex align-items-center justify-content-between gap-2">
                <ng-content select="[header]"></ng-content>
                @if (state === EditableCardState.View || state === EditableCardState.ViewDisabled) {
                    <lib-button
                        [kind]="ButtonKind.Neutral"
                        [prefixIcon]="Icon.Common.Edit"
                        [iconOnly]="true"
                        [disabled]="state === EditableCardState.ViewDisabled"
                        (clicked)="EditClicked()"
                        [qaTag]="qaTag ? qaTag + '-edit-button' : ''">
                    </lib-button>
                }
            </div>
            <ng-content select="[description]"></ng-content>
        </div>

        <ng-content></ng-content>

        @if (state === EditableCardState.Edit || state === EditableCardState.Save || state === EditableCardState.SaveDisabled) {
            <div>
                <mat-divider class="pt-3 mt-3"></mat-divider>
                <lib-layout-row >
                    <ng-container rowRight>

                        <lib-button
                            [kind]="ButtonKind.Secondary"
                            [stretch]="isMobile"
                            [qaTag]="qaTag ? qaTag + '-cancel-button' : ''"
                            [disabled]="state === EditableCardState.Save"
                            (clicked)="CancelClicked()">
                            <ng-container label><ng-content select="[secondaryButtonText]"></ng-content></ng-container>
                        </lib-button>

                        <lib-button
                            [kind]="ButtonKind.Primary"
                            (clicked)="SaveClicked()"
                            [disabled]="state === EditableCardState.Save || state === EditableCardState.SaveDisabled"
                            [loading]="state === EditableCardState.Save"
                            [qaTag]="qaTag ? qaTag + '-save-button' : ''"
                            [stretch]="isMobile">
                            <ng-container label><ng-content select="[primaryButtonText]"></ng-content></ng-container>
                        </lib-button>

                    </ng-container>
                    <ng-container rowLeft>
                        <ng-content select="[buttonRowLeft]"></ng-content>
                    </ng-container>
                </lib-layout-row>
            </div>
        }
    </div>
</ng-template>
